const $ = window.jQuery;

$(document).ready(function () {

    $('#print').on('click', function () {
        //embeded pdf breaks this. fix?
        window.print();
    });
});
